import { Routes, Route, Navigate } from "react-router-dom";
import PantallaPrincipal from "../pages/Pantalla_Principal";
import RegistrarAlumnos from "../pages/registrar-alumnos";
import ConsultarAlumnos from "../pages/consultar-alumnos";

// Registrar
import RegistrarCalificaciones from "../pages/registrar_calificaciones";
import RegistrarCalificacionesXGrupo from "../pages/registrar_calificacionxgrupo";
import RegistrarHorarios from "../pages/registrar_horarios";
import RegistrarHorariosDocente from "../pages/registrar_horarios_docente";
import RegistrarCategoriaMaterias from "../pages/Registrar-categoria-materias";
import RegistrarDocentes from "../pages/registrar-docentes";
import RegistrarEvidencias from "../pages/registrar-evidencias";
import RegistrarGrupos from "../pages/registrar-grupos";
import RegistrarMaterias from "../pages/registrar-materias";
import RegistrarPlaneaciones from "../pages/registrar-planeaciones";
import TraspasoR from "../pages/traspaso_historicoregistro";
import RegistrarPlaneacionesDocentes from "../pages/registrar-planeaciones-Docentes"
import RegistrarEvidenciasDocentes from "../pages/registrar-evidencias-Docentes"

// Modificar
import ModificarAlumnos from "../pages/modificar-alumnos";
import ModificarCategoria from "../pages/modificar-categoria";
import ModificarCoordinador from "../pages/mod-coordinador";
import ModificarDirectora from "../pages/modificar-directora";
import ModificarDocentes from "../pages/mod_docentes";
import ModificarEvidencias from "../pages/modificar-evidencias";
import ModificarGrupos from "../pages/modificar_grupos";
import ModificarMaterias from "../pages/modificar_materias";

// Consultar
import ConsultarCategoria from "../pages/consultar_categoria";
import ConsultarCalificaciones from "../pages/consultar_calificaciones";
import ConsultarCoordinador from "../pages/consultar-coordinador";
import ConsultarDirectora from "../pages/consultar-directora";
import ConsultarDocentes from "../pages/consultar_docentes";
import ConsultarEvidencias from "../pages/consultar-evidencias";
import ConsultarEvidenciasDocente from "../pages/consultar-evidencias-Docentes";
import ConsultarGrupos from "../pages/consultar_grupos";
import ConsultarHorarios from "../pages/consultar_horarios";
import ConsultarHorarioDocente from "../pages/consultar_docentehorario";
import ConsultarHorarioGrupo from "../pages/consultar_horarioxgrupo";
import ConsultarMateria from "../pages/consultar_materias";
import ConsultarGruposCalificaciones from "../pages/consultar_gruposcalificaciones";
import ConsultarPlaneaciones from "../pages/consultar-planeaciones";
import ConsultarPlaneacionesDocentes from "../pages/consultar-planeaciones-Docentes";
import ConsultarAlumnoHorario from "../pages/consultar_alumnohorario";
import ConsultarDocenteHorario from "../pages/consultar_horarioxdocente";
import ConsultarInfoAlumno from "../pages/consultar_informacion_alumno";
import ConsultarInfoDocente from "../pages/consultar_informacion_docente";
import ConsultarCalificacionesParaDocentes from "../pages/consultar_calificaciones_paradocentes";
import ConsultarInfoCoordinadora from "../pages/consultar_informacion_coordinadora";
import ConsultarInfoDirectora from "../pages/consultar_informacion_directora";
import ConsultarCalAlumno from "../pages/consultar_calificaciones_alumno";
import ConsultarDocHG from "../pages/consultar_horariodocente";
import TraspasoC from "../pages/traspaso_historico_consultas";

const ContenidoDinamico = () => (
  <Routes>
    {/* Inicio dentro del panel */}
    <Route index element={<PantallaPrincipal />} />
    <Route path="inicio" element={<PantallaPrincipal />} />

    {/* Registrar */}
    <Route path="registrar-alumnos" element={<RegistrarAlumnos />} />
    <Route path="registrar-calificaciones" element={<RegistrarCalificaciones />} />
    <Route path="registrar_calificacionxgrupo" element={<RegistrarCalificacionesXGrupo />} />
    <Route path="registrar-horarios" element={<RegistrarHorarios />} />
    <Route path="registrar-horarios-docente" element={<RegistrarHorariosDocente />} />
    <Route path="registrar-categoria-materias" element={<RegistrarCategoriaMaterias />} />
    <Route path="registrar-docentes" element={<RegistrarDocentes />} />
    <Route path="registrar-evidencias" element={<RegistrarEvidencias />} />
    <Route path="registrar-grupos" element={<RegistrarGrupos />} />
    <Route path="registrar-materias" element={<RegistrarMaterias />} />
    <Route path="registrar-planeaciones" element={<RegistrarPlaneaciones />} />
    <Route path="registrar-planeaciones-docentes" element={<RegistrarPlaneacionesDocentes />} />
    <Route path="registrar-evidencias-docentes" element={<RegistrarEvidenciasDocentes />} />

    {/* Modificar */}
    <Route path="modificar-alumnos" element={<ModificarAlumnos />} />
    <Route path="modificar-categoria" element={<ModificarCategoria />} />
    <Route path="modificar-coordinador" element={<ModificarCoordinador />} />
    <Route path="modificar-directora" element={<ModificarDirectora />} />
    <Route path="modificar-docentes" element={<ModificarDocentes />} />
    <Route path="modificar-evidencias" element={<ModificarEvidencias />} />
    <Route path="modificar-grupos" element={<ModificarGrupos />} />
    <Route path="modificar-materias" element={<ModificarMaterias />} />

    {/* Consultar */}
    <Route path="consultar-alumnos" element={<ConsultarAlumnos />} />
    <Route path="consultar-informacion-alumno" element={<ConsultarInfoAlumno />} />
    <Route path="consultar-calificaciones-alumno" element={<ConsultarCalAlumno />} />
    <Route path="consultar-categoria" element={<ConsultarCategoria />} />
    <Route path="consultar-calificaciones" element={<ConsultarCalificaciones />} />
  <Route path="consultar-grupos-calificaciones" element={<ConsultarGruposCalificaciones />} />
    <Route path="consultar-coordinador" element={<ConsultarCoordinador />} />
    <Route path="consultar-directora" element={<ConsultarDirectora />} />
    <Route path="consultar-docentes" element={<ConsultarDocentes />} />
    <Route path="consultar-evidencias" element={<ConsultarEvidencias />} />
    <Route path="consultar-evidencias-docentes" element={<ConsultarEvidenciasDocente />} />
    <Route path="consultar-grupos" element={<ConsultarGrupos />} />
    <Route path="consultar-horarios" element={<ConsultarHorarios />} />
    <Route path="consultar-horariodocente" element={<ConsultarHorarioDocente />} />
    <Route path="consultar-horarioxgrupo" element={<ConsultarHorarioGrupo />} />
    <Route path="consultar-materias" element={<ConsultarMateria />} />
    <Route path="consultar-planeaciones" element={<ConsultarPlaneaciones />} />
    <Route path="consultar-planeaciones-docentes" element={<ConsultarPlaneacionesDocentes />} />
    <Route path="consultar-alumnohorario" element={<ConsultarAlumnoHorario />} />
    <Route path="consultar-docentehorario" element={<ConsultarDocenteHorario />} />
    <Route path="consultar-docentehorariogeneral" element={<ConsultarDocHG />} />
    <Route path="consultar_informacion_docente" element={<ConsultarInfoDocente />} />
    <Route path="consultar_calificaciones_paradocentes" element={<ConsultarCalificacionesParaDocentes />} />
  <Route path="consultar-informacion-coordinadora" element={<ConsultarInfoCoordinadora />} />
    <Route path="consultar_informacion_directora" element={<ConsultarInfoDirectora />} />

    {/* Traspaso histórico */}
    <Route path="registrar-traspaso" element={<TraspasoR />} />
    <Route path="consultar-traspaso" element={<TraspasoC />} />

    {/* Fallback opcional */}
    <Route path="*" element={<Navigate to="inicio" replace />} />
  </Routes>
);

export { ContenidoDinamico };

export default function App() {
  return <ContenidoDinamico />;
}
